module.exports = __webpack_public_path__ + "img/INTERIOR-JIMNY-2.f701b92c.jpg";